var React = require('react');

function DollarIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.7275 4V25","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M18.5 7.81787H11.3409C10.4548 7.81787 9.60507 8.16986 8.97853 8.7964C8.35199 9.42294 8 10.2727 8 11.1588C8 12.0448 8.35199 12.8946 8.97853 13.5212C9.60507 14.1477 10.4548 14.4997 11.3409 14.4997H16.1136C16.9997 14.4997 17.8495 14.8517 18.476 15.4782C19.1026 16.1048 19.4545 16.9545 19.4545 17.8406C19.4545 18.7267 19.1026 19.5764 18.476 20.203C17.8495 20.8295 16.9997 21.1815 16.1136 21.1815H8","stroke":"#3D75FF","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

DollarIcon.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = DollarIcon;

DollarIcon.default = DollarIcon;
